import React from 'react';
const Example = () => (<div>
        <div className="progress">
            <div className="progress-bar bg-brand-orange progress-bar--label-right" role="progressbar" aria-valuenow={54} aria-valuemin={0} aria-valuemax={100} style={{
        width: '54%',
    }}>
                54 %
            </div>
        </div>

        <div className="progress">
            <div className="progress-bar bg-brand-orange progress-bar--label-right" role="progressbar" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100} style={{
        width: '75%',
    }}>
                75 %
            </div>
        </div>
    </div>);
export default Example;
